<ng-container *ngIf="form != undefined">
    <div [formGroup]="form">
        <div class="general" id="3">
            <div class="title-area">
                <h1>Informe seus dados</h1>
            </div>
            <ng-container [ngSwitch]="type_contact_response">
                <div *ngSwitchCase="'Email'" class="input-area">
                        <input type="text" id="name" name="name" formControlName="name" placeholder="Seu nome *">
                        <div *ngIf="form.get('name').invalid && form.get('name').touched" class="invalid">
                            <small>Nome obrigatório.</small>
                        </div>
                        <input type="email" name="email" pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,}$" formControlName="participant_key" placeholder="Seu email *" appParticipantKeyValidator [survey]="survey">    
                        <ng-container *ngIf="form.get('participant_key').errors != null">
                            <div class="invalid" *ngIf="form.get('participant_key').touched && form.get('participant_key').errors.required">
                              <small>Email Obrigatório</small>
                            </div>
                            <div class="invalid" *ngIf="form.get('participant_key').invalid && form.get('participant_key').errors.pattern">
                              <small>Email Inválido</small>
                            </div>
                            <div class="invalid" *ngIf="form.get('participant_key').invalid && form.get('participant_key').errors.partipant_key_valid">
                                <small>Esse email já respondeu essa pesquisa</small>
                            </div>
                        </ng-container>
                </div>
                <div *ngSwitchCase="'Phone'" class="input-area">
                    <input type="text" name="name" formControlName="name" placeholder="*Seu nome">
                    <div *ngIf="form.get('name').invalid && form.get('name').touched" class="invalid">
                        <small>Nome obrigatório.</small>
                    </div>
                    <div class="first-tel-area">
                        <ngx-intl-tel-input [cssClass]="'custom'"
                            [enableAutoCountrySelect]="true" [enablePlaceholder]="true" [searchCountryPlaceholder]="'Selecionar país'" [searchCountryFlag]="true"
                            [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]" [selectFirstCountry]="false"
                            [selectedCountryISO]="CountryISO.Brazil" [maxLength]="15"
                            [phoneValidation]="true" [separateDialCode]="separateDialCode"
                            [numberFormat]="PhoneNumberFormat.National" name="phone" formControlName="participant_key" appParticipantKeyValidator [survey]="survey">
                        </ngx-intl-tel-input>
                        <ng-container *ngIf="form.get('participant_key').errors != null">
                            <div class="invalid" *ngIf="form.get('participant_key').touched && form.get('participant_key').errors.required">
                              <small>Número Obrigatório</small>
                            </div>
                            <div class="invalid" *ngIf="form.get('participant_key').invalid && form.get('participant_key').errors.validatePhoneNumber">
                              <small>Número Inválido</small>
                            </div>
                            <div class="invalid" *ngIf="form.get('participant_key').invalid && form.get('participant_key').errors.partipant_key_valid">
                                <small>Esse número já respondeu essa pesquisa</small>
                            </div>
                        </ng-container>
                    </div>
                </div>
                <ng-container *ngSwitchDefault>
                    <div class="name-area">
                        <input type="text" name="name" formControlName="name" placeholder="Seu nome *">
                    </div>
                    <div *ngIf="form.get('name').invalid && form.get('name').touched" class="invalid">
                        <small>Nome obrigatório.</small>
                    </div>
                    <div class="radio-area">
                        <div class="form-area">
                            <div class="form-check form-check-inline" style="margin-right: 2.4rem;">
                                <input class="form-check-input" [ngStyle]="{'background-color': objColor['background-color']}" type="radio" name="radio-all" id="radio1" value="email" (click)="selectTypeKey(true)" checked>
                                <label class="form-check-label" for="flexRadioDefault1">
                                Email
                                </label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" [ngStyle]="{'background-color': objColor['background-color']}" type="radio" name="radio-all" value="phone" id="radio2" (click)="selectTypeKey(false)">
                                <label class="form-check-label" for="flexRadioDefault2">
                                Celular
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="email-area" *ngIf="selectType">
                        <input type="email" name="participant_key" pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,}$" formControlName="participant_key" placeholder="*Seu email" appParticipantKeyValidator [survey]="survey">
                        <ng-container *ngIf="form.get('participant_key').errors != null">
                            <div class="invalid" *ngIf="form.get('participant_key').touched && form.get('participant_key').errors.required">
                              <small>Email Obrigatório</small>
                            </div>
                            <div class="invalid" *ngIf="form.get('participant_key').invalid && form.get('participant_key').errors.pattern">
                              <small>Email Inválido</small>
                            </div>
                            <div class="invalid" *ngIf="form.get('participant_key').invalid && form.get('participant_key').errors.partipant_key_valid">
                                <small>Esse email já respondeu essa pesquisa</small>
                            </div>
                          </ng-container>
                    </div> 
                    <div class="tel-area" *ngIf="!selectType">
                        <ngx-intl-tel-input [cssClass]="'custom'"
                            [enableAutoCountrySelect]="true" [enablePlaceholder]="true" [searchCountryPlaceholder]="'Selecionar país'" [searchCountryFlag]="true"
                            [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]" [selectFirstCountry]="false"
                            [selectedCountryISO]="CountryISO.Brazil" [maxLength]="15"
                            [phoneValidation]="true" [separateDialCode]="separateDialCode"
                            [numberFormat]="PhoneNumberFormat.National" name="participant_key" formControlName="participant_key" class="ngx-tel" appParticipantKeyValidator [survey]="survey">
                        </ngx-intl-tel-input>
                        <ng-container *ngIf="form.get('participant_key').errors != null">
                            <div class="invalid" *ngIf="form.get('participant_key').touched && form.get('participant_key').errors.required">
                              <small>Número Obrigatório</small>
                            </div>
                            <div class="invalid" *ngIf="form.get('participant_key').invalid && form.get('participant_key').errors.validatePhoneNumber">
                              <small>Número Inválido</small>
                            </div>
                            <div class="invalid" *ngIf="form.get('participant_key').invalid && form.get('participant_key').errors.partipant_key_valid">
                                <small>Esse número já respondeu essa pesquisa</small>
                            </div>
                        </ng-container>
                    </div>
                </ng-container>          
            </ng-container>
            <div class="check-area">
                <div class="form-check">
                    <input class="form-check-input" #check
                    type="checkbox" name="termuse" formControlName="termuse" [ngStyle]="check.checked ? objColor : ''">
                    <label class="form-check-label check-label">
                        * Seus dados serão mantidos em sigilo. O nome, telefone ou email são solicitados com a finalidade de identificar a resposta. Caso necessário poderemos entrar em contato. Concordo.
                    </label>
                </div>
            </div>
            <div class="button-finish">
                <button type="submit" [ngStyle]="objColor" [disabled]="!formIsValid()" (click)="finishQuestion()">{{ btnSubmit }}</button>
            </div>
        </div>
    </div>
</ng-container>
